/**
 * Lazy loads back gorund images and also chooses between webp and default file version 
 * Requires Modernizer-Webp to know if the browser supports webp or not assets/js/Libs/Modernizr-Webp.js
 * Any image with the class rc-bg will be picked up
 * Data attribute for webp URL is: data-img-webp
 * Data attribute for default URL is: data-img-default
 */

function init_bg_images(){

    var els = Array.from(document.querySelectorAll('.rc-bg:not(.rc-bg-loaded)'));
    // console.log('init_bg_images', els);
    for (let index = 0; index < els.length; index++) {
        lazy_init_bg_images(els[index]);
    }

}

function init_bg_image(selector){
    var webp_src = $(selector).attr('data-img-webp');
    var default_src = $(selector).attr('data-img-default');

    // console.log('init_bg_image', selector, webp_src, default_src, $('html').hasClass('webp'));

    if( (typeof webp_src !== 'undefined' && webp_src !== 'undefined' && webp_src !== null && webp_src !== '') && $('html').hasClass('webp') ){
        $(selector).css(`background-image`, `url('${webp_src}')`);
    }else{
        $(selector).css(`background-image`, `url('${default_src}')`);
    }

    $(selector).addClass('rc-bg-loaded');
}

function lazy_init_bg_images(selector)
{
    // console.log('lazy_init_bg_images', selector);
    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(50) && window.$(selector).is(':visible') ){
            init_bg_image(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
    selector.addEventListener('lazy_init_bg_images', lazy_init_callback, false);
}

export default init_bg_images;